var map = {
	"./action.png": 8096,
	"./arcade.png": 9214,
	"./board.png": 7976,
	"./cards.png": 7269,
	"./casino.png": 6731,
	"./casual.png": 9749,
	"./home_icon_1.png": 2903,
	"./home_icon_2.png": 4428,
	"./home_icon_3.png": 7317,
	"./home_icon_4.png": 3018,
	"./kids.png": 1837,
	"./logic.png": 5398,
	"./play.png": 7480,
	"./sport.png": 2226,
	"./sports.png": 7027,
	"./tests.png": 8183
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 393;